<template>
  <div>
    <Homepage />
  </div>
</template>
<script>
import Homepage from "@/components/Homepage";
export default {
  components: {
    Homepage,
  },
  created() {
    if (localStorage.getItem("DDLotAdmin") === null) {
      this.$router.push("/");
    }
  },
};
</script>
